import deepwell from "@/assets/landing/work-deepwell.jpg";
import twinPalms from "@/assets/landing/work-twin-palms.jpg";
import desertHouse from "@/assets/landing/work-desert-house.jpg";
import southCanyon from "@/assets/landing/work-south-canyon.jpg";
import indianCanyons from "@/assets/landing/work-indian-canyons.jpg";

export interface SelectedProject {
  id: string;
  name: string;
  neighborhood: string;
  coverImage: string;
  coverAlt: string;
  thesis: string;
  services: string[];
  investmentRange?: string;
  /** Reserved for before/after pairs and extended galleries. */
  beforeImages?: string[];
  afterImages?: string[];
  gallery?: string[];
}

export const selectedProjects: SelectedProject[] = [
  {
    id: "desert-house-001",
    name: "DESERT HOUSE 001",
    neighborhood: "Old Las Palmas",
    coverImage: desertHouse,
    coverAlt:
      "Entry garden of a low concrete modernist home with decomposed granite, boulders, a desert willow and ocotillo in morning light",
    thesis:
      "A single-plane concrete house set into a loose field of granite, ocotillo and mesquite — the garden reads as desert floor, not decoration.",
    services: ["Landscape Design", "Installation", "Stewardship"],
    investmentRange: "$50K–$100K",
  },
  {
    id: "twin-palms-residence",
    name: "TWIN PALMS RESIDENCE",
    neighborhood: "Twin Palms",
    coverImage: twinPalms,
    coverAlt:
      "Pool terrace at dusk with warm lighting washing over sculptural agaves and golden barrel cacti against a dark modernist house",
    thesis:
      "The house disappears at night; the planting does not. A dusk scheme built around washed walls, lit silhouettes and a still pool.",
    services: ["Landscape Design", "Installation", "Lighting"],
    investmentRange: "$100K+",
  },
  {
    id: "deepwell-house",
    name: "DEEPWELL HOUSE",
    neighborhood: "Deepwell Estates",
    coverImage: deepwell,
    coverAlt:
      "Courtyard with concrete pavers, a sculptural columnar cactus, an olive tree and a terracotta container against a white stucco wall",
    thesis:
      "One wall, one tree, one cactus. The courtyard was reduced until every remaining element could hold the afternoon shadow alone.",
    services: ["Exterior Edit", "Installation"],
    investmentRange: "$25K–$50K",
  },
  {
    id: "south-canyon-court",
    name: "SOUTH CANYON COURT",
    neighborhood: "Indian Canyons",
    coverImage: southCanyon,
    coverAlt:
      "Shaded outdoor seating court with a weathered teak bench and olive trees in large concrete containers on gravel ground",
    thesis:
      "An olive court under a dark shade structure — an outdoor room for slow mornings, sheltered from the west sun and the street.",
    services: ["Landscape Design", "Installation", "Containers"],
  },
  {
    id: "indian-canyons-residence",
    name: "INDIAN CANYONS RESIDENCE",
    neighborhood: "Indian Canyons",
    coverImage: indianCanyons,
    coverAlt:
      "Stepping-stone path through drought-tolerant planting of penstemons and barrel cacti toward a steel-and-glass entry",
    thesis:
      "A procession, not a path. Floating concrete steps set through penstemon and barrel cactus turn the approach into the design.",
    services: ["Landscape Design", "Installation", "Stewardship"],
  },
];
